import { mapConsentRecordsToTableData } from 'app/pages/loanApplication/tabs/underwritingCDS/Consent/Consent.utils';
import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';

const selectLoanConsents = createSelector(
  selectLoanApplication,
  ({ loanConsents }) => loanConsents,
);

export const selectApplicationConsentRecords = createSelector(
  selectLoanConsents,
  ({ records }) => records || [],
);

const selectApplicationCreditConsentDate = createSelector(
  selectLoanConsents,
  ({ creditConsentDate }) => creditConsentDate,
);

export const selectConsentTableData = createSelector(
  selectApplicationConsentRecords,
  selectApplicationCreditConsentDate,
  (records, creditConsentDate) => mapConsentRecordsToTableData({ records, creditConsentDate }),
);
